import { render, staticRenderFns } from "./NovaJustificativaMassaPage.vue?vue&type=template&id=24600050"
import script from "./NovaJustificativaMassaPage.vue?vue&type=script&lang=js"
export * from "./NovaJustificativaMassaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports